import React, {useEffect,useState} from 'react'
import '../assets/css/style.css'
import '../assets/animate/animate.css'
import axios from 'axios'
import BASE_URL from '../context/AppConfig'
import IMG_URL from '../context/AppImgConfig'

function Blog() {
    const [projects, setProjects] =useState([])

    useEffect(() => {
      axios.get(`${BASE_URL}/projects/`)
      .then((res) => {
        setProjects(res.data);
      })
      .catch((err) => {
        console.log(err)
      });
    },[]);
  return (
    <div className="blog">
                <div className="container">
                    <div className="section-header text-center">
                        <p>Latest Blog</p>
                        <h2>Latest From Our Blog</h2>
                    </div>
                    <div className="row">
                        
                            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.2s" >
                            <div className="blog-item">
                                <div className="blog-img">
                                    <img src="img/rise.png" alt="Image"/>
                                </div>
                                <div className="blog-title">
                                    <h3>Rise Food Mall</h3>
                                    <a className="btn" href="">+</a>
                                </div>
                                <div className="blog-meta">
                                    <p>By<a href="">Admin</a></p>
                                    <p>In<a href="">Construction</a></p>
                                </div>
                                <div className="blog-text">
                                    <p>
                                        Rise Food Mall is one of the flagship commercial projects constructed by Saara Constructions, designed to become a vibrant hub for food, retail, and entertainment in the region.
                                    </p>
                                </div>
                            </div>
                        </div>
                            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.2s" >
                            <div className="blog-item">
                                <div className="blog-img">
                                    <img src="img/grandthum.jpg" alt="Image"/>
                                </div>
                                <div className="blog-title">
                                    <h3>Grand Thum</h3>
                                    <a className="btn" href="">+</a>
                                </div>
                                <div className="blog-meta">
                                    <p>By<a href="">Admin</a></p>
                                    <p>In<a href="">Construction</a></p>
                                </div>
                                <div className="blog-text">
                                    <p>
                                        Gand Thumb is an exclusive residential project developed with a focus on comfort, safety, and modern living. Saara Construction delivered this project with precision engineering and superior craftsmanship to create homes that offer both elegance and stability.
                                    </p>
                                </div>
                            </div>
                        </div>
                            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.2s" >
                            <div className="blog-item">
                                <div className="blog-img">
                                    <img src="img/cyberthum.png" alt="Image"/>
                                </div>
                                <div className="blog-title">
                                    <h3>Cyber Thum</h3>
                                    <a className="btn" href="">+</a>
                                </div>
                                <div className="blog-meta">
                                    <p>By<a href="">Admin</a></p>
                                    <p>In<a href="">Construction</a></p>
                                </div>
                                <div className="blog-text">
                                    <p>
                                        Cyberthum is a hi-tech commercial complex designed to support corporate offices, retail centers, co-working spaces, and leisure zones—all within one intelligently crafted structure.
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                            
                        
                       
                        
                    </div>
                </div>
            </div>
  )
}

export default Blog
